import { useEffect, useState } from "react";
import * as TmdbApi from "../api/tmdb";
import "./Backdrop.css";

const Backdrop = (props) => {
    const { item } = props;

    const [backdrop, setBackdrop] = useState(null);

    useEffect(() => {
        const loadBackdrop = async () => {
            try {
                setBackdrop(await TmdbApi.getBackdrop(item.ids.tmdb));
            } catch (e) {
                console.log(`Failed to load poster for ${item.title}: ${e}`);
            }
        };
        if (item != null) {
            loadBackdrop();
        }
    }, [item]);

    return (
        <>
            <div className="backdrop">
                <div className="emptyBackdrop" />
                {backdrop && (
                    <img src={backdrop} className="backdropImg" alt="" />
                )}
            </div>
        </>
    );
};

export default Backdrop;
